<template>
    <v-container class="pa-0 pb-12" v-if="SelectedEvent">
		<v-row v-show="HasError"><v-col class="py-1">
            <error></error>
		</v-col></v-row>
		<v-row class="px-3 scroll-wrapper" ref="row">
			<v-col
				cols="12"
				md="12" class="pa-0">
				<v-card color="#000" width="100%" class="mx-auto" rounded="0" flat>
					<v-card-title class="tabel-header">
					{{SelectedEvent.name}}
					</v-card-title>
					<v-card-text class="pa-0 content">
						<form onsubmit="return false;" class="scroll-wrapper">
							<v-row><v-col>
								<c-input
									v-model="form.name"
									:title="$t('text.name')"
									labelWidth="10%"
									:error="errors.name"
									@validate="validateName"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.street"
									:title="$t('text.street')"
									:error="errors.street"
									@validate="validateStreet"
									labelWidth="10%"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.zip"
									:title="$t('text.zip')"
									:error="errors.zip"
									@validate="validateZip"
									labelWidth="10%"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.city"
									:title="$t('text.location')"
									:error="errors.city"
									@validate="validateCity"
									labelWidth="10%"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.country"
									:title="$t('text.country')"
									:error="errors.country"
									@validate="validateCountry"
									labelWidth="10%"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.phone"
									:title="$t('text.phone')"
									:error="errors.phone"
									@validate="validatePhone"
									labelWidth="10%"></c-input>
							</v-col></v-row>
							<v-row><v-col>
								<c-input
									v-model="form.email"
									:title="$t('text.email')"
									labelWidth="10%"
									:error="errors.email"
									@validate="validateEmail"
									:disabled="IsAuthenticated"></c-input>
							</v-col></v-row>
						</form>
					</v-card-text>
				</v-card>
				<spinner :loading="loading"></spinner>
			</v-col>
		</v-row>
		<v-row><v-col>
			<c-button
				:disabled="loading || !validateForm()"
				@click="register"
				type="important"
				:label="$t(`text.registerButton`)">
			</c-button>
			<c-button
				:disabled="loading"
				@click="back"
				class="ml-3"
				:label="$t(`text.abort`)">
			</c-button>
		</v-col></v-row>
	</v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import namespace from '../store/namespace';
import eventRegistrationActions from '../store/actions/eventRegistration';
import Spinner from '../general/Spinner.vue';
import CInput from '../globalComponents/CInput.vue';
import CButton from '../globalComponents/CButton.vue';
import Error from '../general/Error.vue';

import modelState from '../mixins/modelState';
import rules from '../globalComponents/mixins/rules';

export default {
	name: 'NewEventRegistartion',
	mixins: [modelState, rules],
	components: {
		Spinner,
		CInput,
		CButton,
		Error,
	},
	async mounted() {
		this.loading = true;
		try {
			if (this.Links.length === 0) await this.GET_EVENT_REG_LINKS();
			if (this.IsAuthenticated) {
				this.form = await this.GET_USER_DATA();
				this.$nextTick(() => {
					this.validateEmail();
				});
			}
			if (!this.SelectedEvent) {
				// get Event
				const link = this.Links.find(x => x.rel === 'get_by_id');
				if (link) {
					const href = link.href
						.replace('{id}', this.eGuid);
					await this.GET_EVENT_REG_BY_ID(href);
				}
			}
		} finally {
			this.loading = false;
		}
		this.$refs.row.style.height = `${this.calculateHeight}px`;
	},
	watch: {
		calculateHeight() {
			if (this.$refs.row) {
				this.$refs.row.style.height = `${this.calculateHeight}px`;
			}
		},
	},
	data() {
		return {
			form: {
				name: '',
				street: '',
				zip: '',
				city: '',
				country: '',
				phone: '',
				email: '',
			},
			errors: {
				name: {},
				street: {},
				zip: {},
				city: {},
				country: {},
				phone: {},
				email: {},
			},
			loading: false,
		};
	},
	methods: {
		...mapActions(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.GET_EVENT_REG_LINKS,
			eventRegistrationActions.GET_EVENT_REG_BY_ID,
			eventRegistrationActions.ADD_ATTENDENCE,
			eventRegistrationActions.GET_USER_DATA]),
		...mapMutations(namespace.EVENTREGISTRATION, [
			eventRegistrationActions.SET_SELECTED_EVENT,
		]),
		apiErrors(propName) {
			const apiErrors = this.validateProperty(propName);

			if (apiErrors.length > 0) return { show: true, message: apiErrors };

			return {};
		},
		validateForm() {
			const val = Object.keys(this.errors);

			const ret = val.every((p) => {
				if (this.errors[p].show === true) {
					return false;
				}
				return true;
			});

			return ret;
		},
		validateName() {
			this.errors.name = {};
			if (this.isEmpty(this.form.name)) this.errors.name = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.name = this.apiErrors('Name');
		},
		validateStreet() {
			this.errors.street = {};
			if (this.isEmpty(this.form.street)) this.errors.street = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.street = this.apiErrors('Street');
		},
		validateZip() {
			this.errors.zip = {};
			if (this.isEmpty(this.form.zip)) this.errors.zip = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.zip = this.apiErrors('Zip');
		},
		validateCity() {
			this.errors.city = {};
			if (this.isEmpty(this.form.city)) this.errors.city = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.city = this.apiErrors('City');
		},
		validateCountry() {
			this.errors.country = {};
			if (this.isEmpty(this.form.country)) this.errors.country = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.country = this.apiErrors('Country');
		},
		validatePhone() {
			this.errors.phone = {};
			if (this.isEmpty(this.form.phone)) this.errors.phone = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else this.errors.phone = this.apiErrors('Phone');
		},
		validateEmail() {
			this.errors.email = {};
			if (this.isEmpty(this.form.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorEmpty') };
			else if (this.isInvalidEmail(this.form.email)) this.errors.email = { show: true, message: this.$i18n.t('text.errorInvalidEmail') };
			else this.errors.email = this.apiErrors('Email');
		},
		async register() {
			this.loading = true;

			if (this.validateForm()) {
				try {
					this.modelState = {};

					const link = this.Links.find(x => x.rel === 'add_event_att');
					if (link) {
						const href = link.href
							.replace('{eventId}', this.eGuid);
						await this.ADD_ATTENDENCE({ href, data: this.form });

						this.$router.push({ name: 'registrationFinished' });
					}
				} catch (e) {
					console.log(e);
					// if (e.response.status === 422) {
					this.modelState = { errors: { Model: { 0: this.$t('text.errorEmailRegisteredForEvent') } } };
					if (this.modelError()) {
						throw new TypeError(this.modelError());
					}
					// }

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		back() {
			this.$router.go(-1);
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.EVENTREGISTRATION, ['Links', 'SelectedEvent']),
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(namespace.ERROR, ['HasError', 'Message']),
		eGuid() {
			if (this.$route.params.eGuid) return this.$route.params.eGuid;
			return null;
		},
		calculateHeight() {
			const error = this.HasError ? 64 : 0;
			return this.WindowSize.y - 170 - error;
		},
	},
};
</script>

<style lang="scss" scoped>
@import "../globalComponents/style/_globals";

.tabel-header {
	color: $seltec_color;
	height: 40px;
	padding:5px 10px;
	overflow: auto hidden;
	white-space: nowrap;
}

.content {
	background-color: $prim_bg_color;
}

</style>
